import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import classnames from 'classnames';
import { LoginTemplate } from '@sbt-web/auth';
import ErrorBoundary from '@sbt-web/error-boundary';
import { useViewport } from '@sbt-web/hooks';
import { FeatureURI, type AdItem, type TrustProfileInfo, type Shop, type ShopGoogleReviews, type UserProfileInfo, type UserAdInfo, type SearchResult } from '@sbt-web/network/types';
import { AdsAdDetailsBlock } from '@/client/components/Adv/AdSense/adDetails/AdDetailsBlock';
import AdBuy from '@/client/components/Detail/AdBuy';
import { AdReply } from '@/client/components/Detail/AdReply';
import AdvertiserInfo from '@/client/components/Detail/AdvertiserInfo';
import { IncreaseVisibilityButton } from '@/client/components/Detail/IncreaseVisibilityButton';
import { ReplyTime } from '@/client/components/Detail/TrustInfo/ReplyTime';
import UsernameDialog from '@/client/components/Detail/UsernameDialog';
import { getTransactionFlows, TransactionFlow } from '@/shared/tools/transaction/utils';
import { getShowPhone } from '@/tools/phoneNumber/utils';
import useUser from '../../../../contexts/UserContext';
import { AdReplyButtons } from '../../AdReply/components/AdReplyButtons';
import ownClasses from './style/advertiser-info-section.module.scss';
interface Props {
  classes?: string[];
  item: AdItem;
  shop: Shop | null;
  shopGoogleReviews: ShopGoogleReviews | null;
  advertiserProfile: UserProfileInfo | null;
  trustInfo: TrustProfileInfo | null;
  privateUserInfo?: UserAdInfo | null;
  userAds?: SearchResult | null;
}
export type { Props };
export const AdvertiserInfoSection = t0 => {
  const $ = _c(64);
  const {
    classes: t1,
    shop,
    shopGoogleReviews,
    advertiserProfile,
    item,
    trustInfo,
    privateUserInfo,
    userAds
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  const {
    isMobile
  } = useViewport();
  const {
    user,
    requestLogin
  } = useUser();
  const [isContactFormOpened, setIsContactFormOpened] = useState(false);
  const userId = user?.id ?? "";
  let t3;
  let transactionFlows;
  if ($[2] !== item || $[3] !== userId) {
    transactionFlows = getTransactionFlows(item, userId);
    t3 = transactionFlows.includes(TransactionFlow.BuyNow);
    $[2] = item;
    $[3] = userId;
    $[4] = t3;
    $[5] = transactionFlows;
  } else {
    t3 = $[4];
    transactionFlows = $[5];
  }
  const isBuyNowVisible = t3;
  const userIsSeller = userId === item.advertiser.userId;
  const transactionStatus = item.features[FeatureURI.TransactionStatus]?.values[0].value;
  const isSold = transactionStatus != undefined;
  const thisIsMySoldAd = isSold && userIsSeller;
  const thereIsPlaceForContactButton = transactionFlows.length < 2;
  const isOnlyOneTransactionFlowsVisible = transactionFlows.length === 1;
  let t4;
  if ($[6] !== item || $[7] !== userId) {
    t4 = getShowPhone(item, userId);
    $[6] = item;
    $[7] = userId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const showPhone = t4;
  const replyTime = trustInfo?.replyTimeText;
  const shouldShowReplyTimeText = !userIsSeller && !!replyTime;
  let t5;
  if ($[9] !== classes) {
    t5 = classnames(...classes);
    $[9] = classes;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = classnames(ownClasses["seller-info-content"]);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== advertiserProfile || $[13] !== isBuyNowVisible || $[14] !== item || $[15] !== privateUserInfo || $[16] !== shop || $[17] !== shopGoogleReviews || $[18] !== trustInfo || $[19] !== userAds) {
    t7 = <AdvertiserInfo item={item} shop={shop} shopGoogleReviews={shopGoogleReviews} advertiserProfile={advertiserProfile} trustInfo={trustInfo} showContactButton={isBuyNowVisible} privateUserInfo={privateUserInfo} userAds={userAds} />;
    $[12] = advertiserProfile;
    $[13] = isBuyNowVisible;
    $[14] = item;
    $[15] = privateUserInfo;
    $[16] = shop;
    $[17] = shopGoogleReviews;
    $[18] = trustInfo;
    $[19] = userAds;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== advertiserProfile || $[22] !== isContactFormOpened || $[23] !== isMobile || $[24] !== isOnlyOneTransactionFlowsVisible || $[25] !== item || $[26] !== replyTime || $[27] !== requestLogin || $[28] !== shop || $[29] !== shouldShowReplyTimeText || $[30] !== showPhone || $[31] !== thereIsPlaceForContactButton || $[32] !== thisIsMySoldAd || $[33] !== userId || $[34] !== userIsSeller) {
    t8 = !isMobile && !thisIsMySoldAd && <div className={classnames("sticky-cta-bottom-anchor", ownClasses["action-buttons"])}>{!isContactFormOpened && <div className={classnames(ownClasses["buttons-box"])}>{userIsSeller ? <IncreaseVisibilityButton isMobile={isMobile} adUrn={item.urn} /> : <>{shouldShowReplyTimeText && <ReplyTime text={replyTime} />}{thereIsPlaceForContactButton && <AdReplyButtons adUrn={item.urn} isMobile={isMobile} contactAsSecondaryButton={isOnlyOneTransactionFlowsVisible} showPhone={showPhone} item={item} />}<AdBuy item={item} /></>}</div>}<AdReply item={item} isMobile={false} requestLogin={() => new Promise(resolve => {
        requestLogin(LoginTemplate.AdReply, resolve);
      })} userId={userId} onStatusDialogChanged={setIsContactFormOpened} advertiserProfile={advertiserProfile} shop={shop} /></div>;
    $[21] = advertiserProfile;
    $[22] = isContactFormOpened;
    $[23] = isMobile;
    $[24] = isOnlyOneTransactionFlowsVisible;
    $[25] = item;
    $[26] = replyTime;
    $[27] = requestLogin;
    $[28] = shop;
    $[29] = shouldShowReplyTimeText;
    $[30] = showPhone;
    $[31] = thereIsPlaceForContactButton;
    $[32] = thisIsMySoldAd;
    $[33] = userId;
    $[34] = userIsSeller;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  let t9;
  if ($[36] !== isMobile) {
    t9 = isMobile && <AdsAdDetailsBlock isMobile={isMobile} />;
    $[36] = isMobile;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
    t10 = <div className={t6}>{t7}{t8}{t9}</div>;
    $[38] = t7;
    $[39] = t8;
    $[40] = t9;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  let t11;
  if ($[42] !== t10 || $[43] !== t5) {
    t11 = <section className={t5}>{t10}</section>;
    $[42] = t10;
    $[43] = t5;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  let t12;
  if ($[45] !== advertiserProfile || $[46] !== classes || $[47] !== isMobile || $[48] !== isOnlyOneTransactionFlowsVisible || $[49] !== item || $[50] !== replyTime || $[51] !== requestLogin || $[52] !== shop || $[53] !== shouldShowReplyTimeText || $[54] !== showPhone || $[55] !== thereIsPlaceForContactButton || $[56] !== thisIsMySoldAd || $[57] !== userId || $[58] !== userIsSeller) {
    t12 = isMobile && !thisIsMySoldAd && <section className={classnames("sticky-cta-bottom-anchor", ownClasses.stickiness, {
      [ownClasses["with-reply-time"]]: shouldShowReplyTimeText
    }, ...classes)}><div className={classnames(ownClasses["buttons-box"])}>{userIsSeller ? <IncreaseVisibilityButton isMobile={isMobile} adUrn={item.urn} /> : <>{thereIsPlaceForContactButton && <AdReplyButtons adUrn={item.urn} isMobile={isMobile} contactAsSecondaryButton={isOnlyOneTransactionFlowsVisible} showPhone={showPhone} item={item} />}<AdBuy item={item} /></>}</div>{shouldShowReplyTimeText && <ReplyTime text={replyTime} />}<AdReply item={item} isMobile={true} requestLogin={() => new Promise(resolve_0 => {
        requestLogin(LoginTemplate.AdReply, resolve_0);
      })} userId={userId} onStatusDialogChanged={setIsContactFormOpened} advertiserProfile={advertiserProfile} shop={shop} /></section>;
    $[45] = advertiserProfile;
    $[46] = classes;
    $[47] = isMobile;
    $[48] = isOnlyOneTransactionFlowsVisible;
    $[49] = item;
    $[50] = replyTime;
    $[51] = requestLogin;
    $[52] = shop;
    $[53] = shouldShowReplyTimeText;
    $[54] = showPhone;
    $[55] = thereIsPlaceForContactButton;
    $[56] = thisIsMySoldAd;
    $[57] = userId;
    $[58] = userIsSeller;
    $[59] = t12;
  } else {
    t12 = $[59];
  }
  let t13;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <UsernameDialog />;
    $[60] = t13;
  } else {
    t13 = $[60];
  }
  let t14;
  if ($[61] !== t11 || $[62] !== t12) {
    t14 = <>{t11}{t12}{t13}</>;
    $[61] = t11;
    $[62] = t12;
    $[63] = t14;
  } else {
    t14 = $[63];
  }
  return t14;
};
const WrapperComponent = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ErrorBoundary><AdvertiserInfoSection {...props} /></ErrorBoundary>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default WrapperComponent;